import { getGuestId } from './getToken';
import MainApi from '../api-manage/MainApi';
import { guest_checkout } from '../api-manage/ApiRoutes';

/**
 * Ensures a guest_id exists in localStorage.
 * If no guest_id exists, it generates one by calling the guest checkout API.
 * @returns {Promise<string>} The guest_id
 */
export const ensureGuestId = async () => {
  let guestId = getGuestId();
  console.log('ensureGuestId: Current guest_id:', guestId);
  
  if (!guestId) {
    console.log('ensureGuestId: No guest_id found, generating new one...');
    try {
      const { data } = await MainApi.post(guest_checkout);
      if (data?.guest_id) {
        localStorage.setItem('guest_id', data.guest_id);
        guestId = data.guest_id;
        console.log('ensureGuestId: Generated guest_id from API:', guestId);
      }
    } catch (error) {
      console.error('Error generating guest ID:', error);
      // Generate a fallback guest_id if API fails
      const fallbackGuestId = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('guest_id', fallbackGuestId);
      guestId = fallbackGuestId;
      console.log('ensureGuestId: Generated fallback guest_id:', guestId);
    }
  } else {
    console.log('ensureGuestId: Using existing guest_id:', guestId);
  }
  
  return guestId;
};